module.exports = __webpack_public_path__ + "media/images/drawer-f0e12a3a8ba0b0f444a2c13e41c3bc98.svg";